import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import NpcItemEdit from "./NpcItemEdit";
import NpcItemView from "./NpcItemView";
import { NpcItemCard } from "./NpcItem.styles";
import { openTabState } from "./Npc.state";

const NpcItem = ({ clearOpenId, openId, ...props }) => {
    const [edit, setEdit] = useState(false);
    const [openIds, setOpenIds] = useRecoilState(openTabState);
    const onClose = () => {
        setEdit(false)
        setOpenIds(
            openIds
                .filter(id => id !== props.id)
        )
    }

    const onEdit = () => {
        setEdit(true)
        setOpenIds(
            [
                ...openIds,
                props.id,
            ]
                .filter((id, index, self) => self && self.indexOf(id) === index)
        )
    }

    useEffect(() => {
        if (openIds.includes(props.id) || openId === props.id) {
            setEdit(true);
            clearOpenId();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openId]);

    return (
        <NpcItemCard>
            {
                edit
                    ? (
                        <NpcItemEdit
                            onClose={onClose}
                            {...props}
                        />
                    )
                    : (
                        <NpcItemView
                            onEdit={onEdit}
                            {...props}
                        />
                    )
            }
        </NpcItemCard>
    );
};

export default NpcItem;
